import React from 'react';
import { RelatedWrapper } from '../../components/Styled';
import { MarginWrapper, StyledContentWrapper } from '../../components/Styled/StyledWrappers';

interface IWrapper {
  width: number;
  children: React.ReactNode;
}

export const RELATED_MARGIN = '0px auto 42px';
export const RelatedWrapperComponent = (props: IWrapper): JSX.Element => {
  return (
    <RelatedWrapper data-testid="related-elements">
      <StyledContentWrapper width={props.width}>{props.children}</StyledContentWrapper>
      <MarginWrapper margin={RELATED_MARGIN} />
    </RelatedWrapper>
  );
};
